module.exports = __webpack_public_path__ + "assets/img/maximum@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/maximum@2x.png
// module id = 137
// module chunks = 0